<template>
  <div class="uploadAreaWrap">
    <div class="uploadArea" @click="handler" v-if="!getPicSrc">
      <i class="el-icon-plus"></i>
    </div>
    <div v-else class="imageWrap" @click="handler">
      <img :src="getPicSrc" class="image" />
      <i class="el-icon-close" @click.stop="deleteHandler" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    handler: {
      type: Function,
      default: () => {},
    },
    deleteHandler: {
      type: Function,
      default: () => {},
    },
    src: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    getPicSrc() {
      if (!this.src) return;
      if (this.src.indexOf('(') !== -1 && this.src.indexOf(')') !== -1) {
        return this.src.split("(")[1]?.split(")")[0];
      } else {
        return this.src;
      }
    },
  }
};
</script>

<style lang='scss' scoped>
.uploadAreaWrap {
  flex-shrink: 0;
  .uploadArea,
  .imageWrap {
    width: 72px;
    height: 72px;
    margin: 0;
    box-sizing: border-box;
    border-radius: 6px;
  }
  .uploadArea {
    font-size: 20px;
    color: #8c939d;
    line-height: 70px;
    text-align: center;
    border: 1px dashed #d9d9d9;
    background: #fafafa;
    cursor: pointer;
  }
  .imageWrap {
    position: relative;
    overflow: hidden;
    border: 1px solid #ebeef5;
    background: #f5f7fa;
    cursor: pointer;
    .image {
      width: 100%;
      height: 100%;
      object-fit: contain;
      display: block;
    }
    .el-icon-close {
      position: absolute;
      top: 2px;
      right: 2px;
      width: 16px;
      height: 16px;
      line-height: 16px;
      text-align: center;
      color: #fff;
      background: rgba(245, 108, 108, 0.92);
      border-radius: 50%;
      font-size: 12px;
      cursor: pointer;
    }
  }
}
</style>
